var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"1200px"}},[_c('div',{staticClass:"topicon"},[_vm._t("icon")],2),_c('div',{staticClass:"contenttitle"},[_vm._t("title")],2),_c('div',{staticClass:"bottomtext"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }